// yup
import * as yup from 'yup';

// ------------------------------------------------------------------------

const formValidationSchema = yup.object().shape({
  policyOwnershipAndFraudStatement: yup.object().shape({
    applicantName: yup
      .string()
      .min(1, 'Applicant Name must have at least 1 symbol')
      .max(254, 'Applicant Name cannot exceed 254 symbols')
      .required('Applicant Name is required'),
    email: yup
      .string()
      .email('Field must be a valid Email')
      .min(3, 'Email must have at least 3 symbols')
      .max(254, 'Email cannot exceed 254 symbols')
      .required('Email is required'),
    }),
    insured: yup.object().shape({
      state: yup
        .string()
        .notOneOf(['OH', 'ND', 'WA', 'WY'], 'Workers Compensation insurance is not available in monopolistic states')
        .required('State is required'),
    }),
      ownersOfficers: yup.array()
        .of(yup.object().shape({
          ownershipPercentage: yup.number()
            .nullable(true)
            .transform((value, originalValue) => 
              String(originalValue).trim() === "" ? null : value
            )
            .min(0, 'Ownership percentage must be at least 0')
            .max(100, 'Ownership percentage cannot exceed 100'),
        }))
});

export default formValidationSchema;
